import React from 'react';
import PropTypes from 'prop-types';

export const teamDisplayModulePropTypes = {
    team: PropTypes.shape({
        id: PropTypes.number,
        commonName: PropTypes.string,
        placeName: PropTypes.string,
        triCode: PropTypes.string,
        division: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        }),
        conference: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    }).isRequired,
    type: PropTypes.string
};